import React, {useEffect, useRef, useState} from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import OrdersTable from "./OrdersTable";
import ClayDropDown from '@clayui/drop-down';
import ClayButton from '@clayui/button'
import ClayLoadingIndicator from "@clayui/loading-indicator";
import {addCart, deleteCart, fetchCartsData, fetchCurrentCartData} from "../util/Api";
import {useModal} from '@clayui/modal';
import AddCartModal from "./AddCartModal";
import {useTranslation} from "react-i18next";
import ClayIcon from "@clayui/icon";

const CartSelect = () => {
    const { t } = useTranslation();
    const [hasMore, setHasMore] = useState(true);
    const [items, setItems] = useState([])
    const [page, setPage] = useState(1);
    const [expand, setExpand] = useState(false);
    const [query, setQuery] = useState("");
    const [fullLoading, setFullLoading] = useState(false);
    const firstUpdate = useRef(true);
    const {observer, onOpenChange, open} = useModal();
    const [addToCartInProgress, setAddToCartInProgress] = useState(false);

    const [currentCart, setCurrentCart] = useState(null)

    const hasOrderInContext = typeof window.Liferay.CommerceContext.order !== "undefined";

    function fetchCurrentCart() {
        if(!hasOrderInContext) {
            return;
        }
        fetchCurrentCartData()
            .then(cartJson => setCurrentCart(cartJson))
            .catch(error => alert(t("an-unexpected-error-occurred")));
    }

    function fetchData(page) {
        if (page === 1) {
            setFullLoading(true);
        }
        fetchCartsData(page, query)
            .then(response => response.json())
            .then(json => {
                setItems(items => {
                    if (page === 1) {
                        return json.items;
                    } else {
                        return items.concat(json.items);
                    }
                });
                setHasMore(page < json.lastPage);
                setPage(page + 1);
            }).finally(() => setFullLoading(false));
    }

    useEffect(() => {
        if (firstUpdate.current) {
            // Kind of lazy loading. We do not need to fetch data right away
            firstUpdate.current = false;
            fetchCurrentCart();
            return;
        }
        fetchData(1);

    }, [query]);

    const fetchMoreData = () => {
        fetchData(page);
    };

    const queryOnChange = (e) => {
        setQuery(e.target.value);
    }

    const addCartAction = (name, insuranceId, insuranceCaseNumber) => {
        if(insuranceId && insuranceId > 0 && !insuranceCaseNumber) {
            alert(t("please-fill-insurance-case-number"));
            return;
        }
        setAddToCartInProgress(true);
        addCart(name, insuranceId, insuranceCaseNumber)
            .then(response => {
                Liferay.fire("current-order-updated");
                window.refreshMiniCarts();
                window.refreshCartSelect();
            }).catch(error => alert(t("an-unexpected-error-occurred")))
            .finally(() => setAddToCartInProgress(false));
    }

    const deleteAction = (id) => {
        let confirmResult = confirm(t("are-you-sure"));
        if(!confirmResult) {
            return;
        }
        deleteCart(id)
            .then(response => {
                if(response.status === 204) {
                    if(id === currentCart?.id) {
                        window.location.reload();
                    } else {
                        fetchData(1);
                    }
                } else {
                    alert(t("an-unexpected-error-occurred"));
                }
            })
            .catch(error => alert(t("an-unexpected-error-occurred")));
    }

    const cartSelectElement = document.querySelector("up2date-cart-select");
    const supportsInsurance = cartSelectElement && cartSelectElement.getAttribute("support-insurance") === "true";
    return (
        <div>
            {open &&
                <AddCartModal observer={observer} supportsInsurance={supportsInsurance}
                              loading={addToCartInProgress}
                addCartAction={addCartAction}/>
            }

            {currentCart || !hasOrderInContext ? (
                <ClayDropDown
                    active={expand}
                    id="scrollable"

                    // alignmentPosition={alignmentPosition}
                    className="cart-selector-dropdown"
                    menuElementAttrs={{className: 'cart-selector-dropdown-menu'}}
                    onActiveChange={() => {
                        setExpand(oldExpand => {
                            const newExpand = !oldExpand;
                            if(newExpand) {
                                fetchData(1);
                            }
                            return newExpand;
                        });
                    }}

                    trigger={
                        <button className="btn p-0">
                            {expand ? <ClayIcon className={"mr-1"} symbol="angle-up" spritemap={Liferay.ThemeDisplay.getPathThemeImages() + "/clay/icons.svg"}/> :
                                <ClayIcon className={"mr-1"} symbol="angle-down" spritemap={Liferay.ThemeDisplay.getPathThemeImages() + "/clay/icons.svg"} />}
                            {
                                currentCart ? (
                                `${currentCart.id} (${currentCart.customFields.cartCustomName})`
                                ) : <span>{t("no-order-selected")}</span>
                            }
                        </button>
                    }>

                    <ClayDropDown.Section>
                        <input value={query} placeholder="Search" type="text" className="form-control"
                               onChange={queryOnChange}>

                        </input>
                    </ClayDropDown.Section>

                    <ClayDropDown.Divider/>


                    <ClayDropDown.Section>
                        <InfiniteScroll
                            dataLength={items.length}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            loader={<ClayLoadingIndicator/>}
                            scrollableTarget={"scrollable"}
                            height={300}
                        >

                            {!fullLoading && <OrdersTable setExpand={setExpand} setCurrentCart={setCurrentCart} deleteAction={deleteAction} orders={items}/>}

                        </InfiniteScroll>
                    </ClayDropDown.Section>


                    <ClayDropDown.Divider/>

                    <ClayDropDown.Section>
                        <ClayButton displayType="primary" className={"w-100"} onClick={() => onOpenChange(true)}>
                            {t('create-new-order')}
                        </ClayButton>
                    </ClayDropDown.Section>
                </ClayDropDown>

            ) : <div></div>
            }

        </div>
    );
}

export default CartSelect;